
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { EnumMyStudyMenu } from '@xt/client/enums/my'
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import { EnumWaterfallLoadResult } from '@xt/client/enums'
import { Observer } from 'mobx-vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import StudyCard from './views/StudyCard/index.vue'
import MyLayout from '../views/MyLayout/index.vue'

import type { UserInfo } from '@xt/client/entities/user/types'
import type { CommonStudyCardUIData } from '@xt/client/entities/my-v2/types.d'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import lodash from 'lodash'

@Observer
@Component({
  scrollToTop: true,
  components: { MyLayout, StudyCard, InfiniteLoading, EmptyStatus, UserContentPop },
  async asyncData(ctx) {
    // 没有token 用户没登录
    if (!ctx.store.$storeUser.isLogin) {
      ctx.redirect('/')
    }

    const userInfo: UserInfo | undefined = ctx.store.$storeUser.UserInfo || (await ctx.store.$storeUser.onUpdatingUserInfo())

    if (!userInfo) {
      // 异常
      ctx.redirect('/')
    }

    return {
      userInfo: userInfo!
    }
  }
})
export default class MyStudyPage extends Vue {
  userInfo: UserInfo

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get menuKey() {
    return lodash.get(this.$route.query, 'menu', EnumMyStudyMenu.Homework)
  }

  get myStudyMenu() {
    return this.PageStore.menus.map(menu => ({ value: menu.value, label: menu.label }))
  }

  get PageStore() {
    return this.$store.$myV2.Study
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  onResetScroll() {
    this.$nextTick(() => {
      // 当前页面的滚动容器是html
      document.documentElement.scrollTop = 0
    })
  }

  handleChangeType(type: EnumMyStudyMenu) {
    this.PageStore.handleChangeCurrent(type)
    this.onResetScroll()
  }

  handleChangeOption(option: string) {
    this.PageStore.handleChangeOption(option)
    this.onResetScroll()
  }

  async infiniteHandler($state: StateChanger) {
    const result = await this.PageStore.loadData(this.userInfo.id)

    if (result === EnumWaterfallLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (result === EnumWaterfallLoadResult.Error) {
      $state.error()
    }

    if (result === EnumWaterfallLoadResult.Loaded) {
      $state.loaded()
    }

    if (result === EnumWaterfallLoadResult.Complete) {
      if (this.PageStore.list.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  async handleClickCard(data: CommonStudyCardUIData) {
    switch (data.type) {
      case 'homework':
        this.userContentPop?.showPop({ type: 'homework', homeworkId: data.id as number })
        return
      case 'dairy':
        if (typeof data.jumpUrl === 'string' && data.jumpUrl !== '') {
          return
        } else {
          this.userContentPop?.showPop({ type: 'dairy', momentId: `${data.id}` })
          return
        }
      case 'collect':
        if (data.jumpType === 'show' && data.showId) {
          return
        } else if (data.jumpType === 'dairy') {
          this.userContentPop?.showPop({ type: 'dairy', momentId: data.collectionId })
          return
        }
    }
  }

  handleLikeInContentPop({ momentId }: { momentId: string }) {
    const item = this.PageStore.list.find(i => i.id === momentId)

    if (item) {
      this.PageStore.onChangeLikeStatus(item, 'like')
    }
  }

  handleRemoveInContentPop(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    this.PageStore.onRemoveItem(data.type === 'dairy' ? data.momentId : data.homeworkId)

    if (data.type === 'homework') {
      this.userContentPop?.hidePop()
    }
  }

  // 兼容指定 menu 跳转
  init() {
    this.PageStore.handleChangeCurrent(this.menuKey as EnumMyStudyMenu)
  }

  created(): void {
    this.init()
  }
}
